module.exports = __webpack_public_path__ + "static/media/included1.d9fc8ea7.svg";